/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import validationRules from '../utils/validation';

class Layout {
	constructor() {
		this.$body = $('body');
		this.$header = $('.header');
		this.$hiddenHeader = $('.js-top-target');

		this.$nav = $('.nav-wrapper');
		this.$primaryNavItem = $('.primary-nav > li');
		this.$primaryNavItemLink = $('.primary-nav > li > a');
        this.$navToggle = $('.js-nav-toggle');
        this.$navToggleLabel = $('.js-nav-toggle-label');
		this.$navToggleChildren = $('.js-nav-toggle-children');
		this.$searchToggle = $('.js-search-toggle');
		this.$search = $('.js-search');

		this.$headerSearchTextbox = $('.js-search-textbox');

		this.didScroll = false;
		this.lastScrollTop = 0;
		this.delta = 5;

        this.timer = 0;

        this.$menuButton = $('.js-menu-icon');
        this.$menuIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"/></svg>';
        this.$closeIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="times" class="svg-inline--fa fa-times fa-w-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"/></svg>';
    }

    init() {
		this.bindEvents();
		this.initFooterNewsletterSignup();
		this.handleMobileMenuPosition();
		this.handleMainPosition();
    }

    bindEvents() {
		this.$navToggle.on('click', e => { e.preventDefault(); this.toggleNav(e); });

		this.$navToggleChildren.on('click', e => { this.mobileNavItem(e); });
		this.$searchToggle.on('click', e => { this.toggleSearch(e); });

		// on focus header search
		this.$headerSearchTextbox.on('focus', e => { this.expandSearch(e); });
		$('.header-search-prepend-icon').on('click', e => { $('#header-search').focus(); this.expandSearch(e); });

		$('body').on('click', e => { this.collapseSearch(e); });

		$('.header .search').on('click', e => { e.stopPropagation(); });

		// on menu enter
		this.$primaryNavItemLink.on('keydown', e => { this.tabbingNav(e); });

		// open megamenu on hover for desktop
		this.$primaryNavItem.on('mouseover', e => {
			clearTimeout(this.timer);
			$('.js-nav-megamenu').removeClass('open');

			this.openSubmenu(e);
		}).on('mouseleave', e => {
			this.timer = setTimeout(() => {
				this.closeSubmenu(e);
			}, 300);
		});

		//Scrolls back to the top after tabbing through page
		
		this.$hiddenHeader.focus(() => {
			window.scroll({
				top: 0, 
				left: 0, 
				behavior: 'smooth'
			});
		});

		//DataLayer Events
		const telAnchors = $('a[href^=tel]');
		telAnchors.on('click', (e) => {
			if (window.dataLayer !== null && window.dataLayer !== undefined) {
				const isOffice = (typeof officeId !== 'undefined') && officeId !== null && officeId !== '' && officeId !== 999;
				let type = 'Corporate';
				let officeID = '';
				let officeNameNew = '';
				if (isOffice && (typeof officeName !== 'undefined')) {
					type = `${officeName} Office`;
					officeID = `${officeId}`;
					officeNameNew = `${officeName}`;
				}
				window.dataLayer.push({
					event: 'telephone_interaction',
					branchType: type,
					branchID: '999',
					branchName: 'IHC Corporate',
					officeID,
					officeName: officeNameNew
				});
			}
		});

		const mailAnchors = $('a[href^=mailto]');
		mailAnchors.on('click', (e) => {
			if (window.dataLayer !== null && window.dataLayer !== undefined) {
				const isOffice = (typeof officeId !== 'undefined')  && officeId !== null && officeId !== '' && officeId !== 999;
				let branchType = 'Corporate';
				let officeID = '';
				let officeNameNew = '';
				if (isOffice && (typeof officeName !== 'undefined')) {
					branchType = `${officeName} Office`;
					officeID = `${officeId}`;
					officeNameNew = `${officeName}`;
				}
				window.dataLayer.push({
					event: 'email_interaction',
					branchType,
					branchID: '999',
					branchName: 'IHC Corporate',
					officeID,
					officeName: officeNameNew
				});
			}
		});

        //---/ Footer
	}

	handleMainPosition() {
		if ($(window).width() < 992) {
			let headerHeight = $('.header').outerHeight();
			$('#main').css('margin-top', headerHeight);
		} else {
			$('#main').css('margin-top', 0);
		}
	}

	closeSubmenu(e) {
		const target = $(e.currentTarget);

		$(target).closest('li').find('.js-nav-megamenu').removeClass('open');
	}

	expandSearch(e) {
		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			let target = e.currentTarget;
			let parent = $(target).closest('.search');

			$(parent).addClass('focused');
			$(target).val($(target).data('value'));
		}
	}

	collapseSearch(e) {
		if ($('.header .search').hasClass('focused') && !$('#header-search').is(':focus')) {
			$('.header .search').removeClass('focused');
			$('#header-search').data('value', $('.header .search .form-control').val());  
			$('#header-search').val(''); 
		} 
	}

	hasScrolled() {
		let st = $(window).scrollTop();
		let headerHeight = $('.header').outerHeight();
		let bannerHeight = ($('.js-banner').hasClass('closed') || $('.js-banner') === undefined || $('.js-banner').length === 0) ? 0 : $('.js-banner').outerHeight();

		// Make sure they scroll more than delta
		if (Math.abs(this.lastScrollTop - st) <= this.delta) {
			return;
		}

		// If they scrolled down and are past the header, add class .header-up.
		// This is necessary so you never see what is "behind" the header.
		if (st > headerHeight) {
			this.$body.css('padding-top', headerHeight);

			if (st > this.lastScrollTop) {
				// Scroll Down
				this.$body.removeClass('header-down').addClass('header-up');
				this.$header.css('top', -headerHeight);
			}
			else if (st + $(window).height() < $(document).height()) {
				// Scroll Up
				this.$body.removeClass('header-up').addClass('header-down');
				this.$header.css('top', 0 - bannerHeight);
			}
		}
		else if (st <= (bannerHeight + 50)) {
			this.$body.css('padding-top', 0);
			this.$header.css('top', 'auto');
			this.$body.removeClass('header-up').removeClass('header-down');
		}

		this.lastScrollTop = st;
	}

	// clicking on items in mobile nav
	mobileNavItem(e) {
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			e.preventDefault();

			const target = $(e.currentTarget);
			const parent = target.closest('li');

			$(parent).find('> ul').slideToggle();
			$(parent).toggleClass('open');
		}
	}

	openSubmenu(e) {
		const target = $(e.currentTarget);

		$(target).closest('li').find('.js-nav-megamenu').addClass('open');
	}

	handleMobileMenuPosition() {
		//On Init
		if ($(window).width() <= 976) {
			this.handleHeaderSize();
		}
		//On Resize
		$(window).resize(() => {
			let width = $(window).width();  
			if (width <= 976) {
				this.handleHeaderSize();
			} else {
				this.$nav.css('top', 0);
				this.$nav.css('padding-bottom', 0);
			}
			this.handleMainPosition();
		});

		$(document).on('click keypress', '.js-banner-close', e => {
			if ($(window).width() <= 976) {
				this.$nav.css('top', $('.header-inner').outerHeight(true));
			}			
		});		
	}

	handleHeaderSize() {
		let position = $('.header-inner').offset().top + $('.header-inner').outerHeight(true);
		this.$nav.css('top', position);
	}

	// if user hits enter when tabbing on menu items, open mega menu and set tabbing to children
	tabbingNav(e) {
		let target = $(e.currentTarget);

		if (e.keyCode === 13 && target.hasClass('has-dropdown')) {
			e.preventDefault();
			target.closest('li').addClass('focused');
			target.closest('li').find('.js-nav-megamenu').addClass('open');
		}

		let $activeElem = $(document.activeElement);
		let $prevItem = $activeElem.closest('li').prev();

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
			$prevItem.find('.js-nav-megamenu').removeClass('open');
		}

		if (e.shiftKey && (e.keyCode === 9)) {
			$('.js-nav-megamenu').removeClass('open');
		}
	}

	// toggle nav on mobile
	toggleNav(e) {
		if (this.$searchToggle.hasClass('open')) {
			this.toggleSearch();
		}
		$('.js-nav-megamenu').removeAttr('style').closest('li').removeClass('open'); // Open nav with sub menus closed

		if ($(window).width() < 992)
		{
			$('.js-nav-toggle').toggleClass('open');
			const header = $('.header');
			const headerHeight = header[0].offsetHeight;
			$('.nav-wrapper').css('top', headerHeight);
			$('.nav-wrapper').css('padding-bottom', headerHeight);
		}

		this.$nav.slideToggle().toggleClass('open');
        this.$body.toggleClass('nav-open');
	}

	toggleSearch(e) {
		if (this.$nav.hasClass('open')) {
			this.toggleNav();
		}
		this.$nav.slideUp();
		this.$searchToggle.toggleClass('open');
		this.$search.slideToggle();
	}

	initFooterNewsletterSignup() {
		let context = this;
		$('#newsletter-signup-submit').on('click', e => {
			e.preventDefault();
			$('.form-success').addClass('hidden');
			$('.form-error').addClass('hidden');
			context.doFooterSignupValidation();
			if (context.validFooterSignup === true) {
				context.submitNewsletterSignup();
			}
		});
	}

	doFooterSignupValidation() {
		// validate data in reverse verticle order => top most scrollToElement
		this.validFooterSignup = true; // try and make me false
		this.validateEmail();
		//this.validateLastName();
		//this.validateFirstName();

		if (this.validFooterSignup === false) {
			if (this.firstSignupSubmit === false) {
				this.firstSignupSubmit = true;
				// add new events for better ux post 1st submit : realtime validation msging
				this.eventsAfterSubmitionFail();
			}
		}
	}

	validateEmail() {
		let email = $('#Footer_EmailSignUp');
		if (email.val() === undefined || email.val() === '') {
			$('.footer-forms-field-validation-error').html('Please complete all fields to sign up.');
			$('.footer-forms-field-validation-error').removeClass('hidden');
			$('#Footer_EmailSignUp').addClass('error');
			this.validFooterSignup = false;
		} else if (!validationRules.emailValidate(email)) {
			$('.footer-forms-field-validation-error').html('Please provide a valid email.');
			$('.footer-forms-field-validation-error').removeClass('hidden');
			$('#Footer_EmailSignUp').addClass('error');
			this.validFooterSignup = false;
		} else {
			$('.footer-forms-field-validation-error').addClass('hidden');
			$('#Footer_EmailSignUp').removeClass('error');
		}
	}

	eventsAfterSubmitionFail() {
		$('#Footer_EmailSignUp').on('keyup', () => this.validateEmail());
		$('#Footer_EmailSignUp').val('');
	}

	submitNewsletterSignupSuccess(results) {
		// console.log('signup success', results);
		this.signupSubmitSuccess = true;
		$('#Footer_EmailSignUp').val('');
		$('.form-success').removeClass('hidden');
		$('.footer-forms-success-message').addClass('hidden');
	}

	submitNewsletterSignupFail(results) {
		// console.log('signup fail', results);
		this.signupSubmitSuccess = false;
		$('.form-error').removeClass('hidden');
		$('.footer-forms-error-message').removeClass('hidden');
	}

	submitNewsletterSignup() {
		let emailSignup = $('#Footer_EmailSignUp').val();
		let emailTo = $('#Footer_EmailOfficeEmail').val();
		let officeId = $('#Footer_EmailOfficeId').val();
		let data = {
			email: emailSignup,
			SentToEmail: emailTo,
			officeId
		};

		if (window.dataLayer !== null && window.dataLayer !== undefined) {
			const isOffice = (typeof officeId !== 'undefined') && officeId !== null && officeId !== '' && officeId !== 999;
			let type = 'Corporate';
			let officeID = '';
			let officeNameNew = '';
			if (isOffice && (typeof officeName !== 'undefined')) {
				type = `${officeName} Office`;
				officeID = `${officeId}`;
				officeNameNew = `${officeName}`;
			}
			window.dataLayer.push({
				event: 'general_newsletter_subscription',
				branchType: type,
				branchID: '999',
				branchName: 'IHC Corporate',
				officeID,
				officeName: officeNameNew
			});
        }

		$.ajax({
			type: 'POST',
			data: JSON.stringify(data),
			contentType: 'application/json; charset=utf-8',
			url: '/api/registration/subscribe',
			success: (results) => this.submitNewsletterSignupSuccess(results),
			error: (results) => this.submitNewsletterSignupFail(results)
		});
	}
}

export default Layout;